import type { IApiUser, IUser } from 'src/interfaces';

export const mapApiToUser = ({ fullname, ...rest }: IApiUser): IUser => {
  return {
    ...rest,
    fullName: fullname,
  };
};
